import { useEffect, useState } from "react";
import moment from 'moment';

import { fetchData } from "../../lib/utils";

const FinRow = (props) => {
    const { isAfter, content, idx } = props;
    const [isFull, showFull] = useState(false);
    const inital = content.split('\n')
    const res = inital.reduce((agg, item) => {
        if (item.indexOf('-') == 0 && isFull == false && inital.length > 1) {
            return agg;
        }
        agg.push(item);
        return agg;
    }, []);

    return <td>
        {inital.length > 1 ? <div style={{ whiteSpace: 'pre-wrap' }}>
            {res.join('\n')}
        </div> : <div>{res.join('')}</div>}
        {(inital.length !== res.length || isFull) && <button type="button" onClick={() => showFull(!isFull)}
            className='ds-btn is-soft is-sm' style={{ marginTop: 'var(--ds-space-2)' }}>
            {isFull ? 'Show less' : 'Show more'}
        </button>}
        {(idx === 0 && isAfter) && <div className="ds-badge is-warning" style={{ marginTop: 'var(--ds-space-1)' }}>Projection</div>}
    </td>
}


const Financials = (props) => {

    const [finData, setFindAta] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [total, setTotal] = useState(null);
    useEffect(() => {
        fetchData('/api/v1/utils/fins', {}).then(resp => {
            setFindAta(resp.data);
            const sum = resp.data.reduce((total, item) => {
                // console.log(item['Balance'],total)
                // return total + parseFloat(item['Balance'].replace(',',''), 10)

                return 0;
            }, 0)
            // setTotal(sum)
            setHeaders(Object.keys(resp.data[0]))
        })
    }, [])
    return <div className="ds-panel">
        <div className="ds-panel__head">
            <h3 className="ds-panel__title">Utilisation</h3>
            {total !== null && <span className="ds-panel__sub">Bonus projection: {Math.floor(total)}</span>}
        </div>
        <div className="ds-table-wrap">
            <table className="ds-table is-striped">
                <thead>
                    <tr>
                        {headers.map(item => <th key={item}>{item}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {finData.map((row, ri) => {
                        const isAfter = moment(row['Month']).endOf('M').isAfter(Date.now());
                        return <tr key={ri} className={isAfter ? 'is-projection' : ''}>
                            {headers.map((item, idx) => <FinRow key={idx} idx={idx} content={row[item]} isAfter={isAfter} />)}
                        </tr>;
                    })}
                </tbody>
            </table>
        </div>
    </div>;
}

export default Financials;
